import React from 'react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { LicensesInactiveTable } from './component.styles'
import { displayDate, displayAdmins } from 'lib/util'

const LicensesInactive = ({ licenses, currentUser }) => {
  const updatedLicenses = licenses.map((license, licenseIndex) => {
    return {
      ...license,
      dataTestId: `expired-license-subscriptionId-${
        license.subscriptionId
      }-sku-${license.sku}-${licenseIndex + 1}`,
    }
  })
  const columns = [
    {
      title: 'School',
      fieldValue: row => `${row?.site?.name || 'License Not Assigned'}`,
    },
    {
      title: 'Product',
      fieldValue: row => row.product?.description,
    },
    {
      title: 'License Id',
      fieldValue: row => row.nsName || '-',
      cellClassName: 'text-center',
    },
    {
      title: 'Contract Line Id',
      fieldValue: row => row.contractLineNSId || '-',
      cellClassName: 'text-center',
    },
    {
      title: 'Expiration Date',
      fieldValue: row => displayDate(row.expirationDate) || '-',
      sortValue: 'expirationDate',
    },
    {
      title: 'Administrators',
      fieldValue: row => displayAdmins(row?.site, currentUser.email) || '-',
    },
  ]

  return (
    <LicensesInactiveTable
      columns={columns}
      filter={false}
      headThemeLight
      key="expired-users-autotable"
      rows={updatedLicenses}
      sort
    />
  )
}

LicensesInactive.propTypes = {
  currentUser: PropTypes.object.isRequired,
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const mapStateToProps = ({ userProfileManager }) => {
  return {
    currentUser: userProfileManager.profile,
  }
}

export default connect(mapStateToProps)(LicensesInactive)
